import { useState, useCallback } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectSessionToken } from "../../store/sessionSlice";
import { clearSession } from "../../store/sessionSlice";
import { auth } from "../../utils/firebase";
import useIdleTimer from "../../utils/UseIdleTimer";
import IdleTimerPopUp from "../IdleTimerPopup/IdleTimerPopup";

const IDLE_TIMEOUT = 60 * 60 * 1000;    // 60 menit
const WARNING_TIMEOUT = 5 * 60 * 1000;  // 5 menit

const PrivateRoute = ({ children }) => {
  const sessionToken = useSelector(selectSessionToken);
  const dispatch = useDispatch();
  const [isWarningOpen, setIsWarningOpen] = useState(false);

  const handleLogout = useCallback(() => {
    setIsWarningOpen(false);
    dispatch(clearSession());
  }, [dispatch]);

  const handleWarning = useCallback(() => {
    setIsWarningOpen(true);
  }, []);

  const handleActivity = useCallback(() => {
    if (isWarningOpen) {
      setIsWarningOpen(false);
    }
  }, [isWarningOpen]);

  const { resetTimer } = useIdleTimer({
    idleTimeout: IDLE_TIMEOUT,
    warningTimeout: WARNING_TIMEOUT,
    onWarning: handleWarning,
    onLogout: handleLogout,
    onActivity: handleActivity,
  });

  const handleStillHere = useCallback(async () => {
    setIsWarningOpen(false);
    resetTimer();

    // force refresh Firebase token supaya tidak expired
    try {
      await auth.currentUser?.getIdToken(true);
    } catch (e) {
      console.error("Token refresh failed:", e);
    }
  }, [resetTimer]);

  if (!sessionToken) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {children}
      <IdleTimerPopUp
        isOpen={isWarningOpen}
        onStillHere={handleStillHere}
        onLogout={handleLogout}
        warningTimeout={WARNING_TIMEOUT}
      />
    </>
  );
};

export default PrivateRoute;